export const USER_ACTION_OPTIONS = [
    { value: "update", label: "Update" },
    { value: "addAccountManager", label: "Add Account Manager" },
    { value: "updateUserSuspendStatus", label: "Update Suspend Status" },
    { value: "updateUserTagging", label: "Update User Tagging" },
    { value: "updateUserPackage", label: "Update User Package" },
    { value: "chargeUser", label: "Charge User Card" },
    { value: "updateCodValue", label: "Update COD Value" },
]

export const AUDIT_LOG_SUBJECT_OPTIONS = [
    { value: "_User", label: "User" },
    { value: "Merchant", label: "Merchant" },
    { value: "Order", label: "Order" },
    { value: "Settings", label: "Settings" },
]

export const AUDIT_LOG_TYPE_OPTIONS = [
    { value: "USER", label: "User" },
    { value: "ADMIN", label: "Admin" },
    { value: "SETTINGS", label: "Settings" },
]

export const USER_ACTION_LABEL_MAP = Object.fromEntries(
    USER_ACTION_OPTIONS.map(opt => [opt.value, opt.label])
)

export const AUDIT_LOG_SUBJECT_MAP = Object.fromEntries(
  AUDIT_LOG_SUBJECT_OPTIONS.map(opt => [opt.value, opt.label])
)

export const AUDIT_LOG_TYPE_MAP = Object.fromEntries(
  AUDIT_LOG_TYPE_OPTIONS.map(opt => [opt.value, opt.label])
)